export default function music_chart_history() {

  $('.sortable-table').stupidtable();  
  
}